import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the AccountPayment component.
 * Consolidates 9 individual useSelector calls into one, reducing re-renders
 * by only recalculating when userStore, modalStore, or accountsStore change.
 */
export const selectAccountPaymentPageContext = createSelector(
  [
    (state: RootState) => state.userStore,
    (state: RootState) => state.modalStore,
    (state: RootState) => state.accountsStore,
  ],
  (userStore, modalStore, accountsStore) => ({
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    readOnly: !userStore.canReadWriteAccounts,
    primaryActionButton: modalStore.primaryActionButton,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    paymentType: accountsStore.paymentType,
    paymentTypeLoading: accountsStore.paymentTypeLoading,
    paymentTypeLoaded: accountsStore.paymentTypeLoaded,
    makePaymentLoading: accountsStore.makePaymentLoading,
  })
);
